var infoCurrentTab = null;
var infoButtons = [];
var infoBorderBar = null;
var infoInit = false;

function openTab(evt, cityName)
{
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent-cus");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks-cus");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
  infoCurrentTab = evt.currentTarget;
  
  if(infoInit)
    infoMoveToActive();
}

document.addEventListener("DOMContentLoaded", function()
{
  infoCurrentTab = document.getElementById("tab-cus-active");
  infoCurrentTab.click();

  infoBorderBar = document.getElementsByClassName("info-bar-bottom-border");
  if(infoBorderBar.length >= 1)
  {
    infoBorderBar = infoBorderBar[0];
  }

  let infoButtonBar = document.getElementsByClassName('info-button-bar');
  if( infoButtonBar.length >= 1)
  {
    infoButtonBar = infoButtonBar[0];
  }
  infoButtons = infoButtonBar.getElementsByTagName('button');
  
  // for(let button of infoButtons)
  // {
  //   button.addEventListener("mouseenter", infoMoveBorderBar);
  // }
  // infoButtonBar.addEventListener("mouseleave", infoMoveToActive);
  infoInit = true;
  infoMoveToActive();
});

function infoMoveBorderBar(e)
{
  let button = e.currentTarget;

  infoBorderBar.style.width = button.clientWidth + "px";
  infoBorderBar.style.left = button.offsetLeft - button.parentElement.offsetLeft + "px";
}

function infoMoveToActive()
{
  infoBorderBar.style.width = infoCurrentTab.clientWidth + "px";
  infoBorderBar.style.left = infoCurrentTab.offsetLeft - infoCurrentTab.parentElement.offsetLeft + "px";
}